import React, { useEffect } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { deleteManageByIdAction } from "../../../../actions/mangeActionV2";
import Progress from "../../../../components/Loader/Progress ";
import { useTranslation } from "react-i18next";
import { showErrorToast, showSuccessToast } from "../../../../slices/toastSlice";
import { resetDelete } from "../../../../slices/manageSliceV2";

const DeleteConfirmationModal = ({
  isOpen,
  onClose,
  deleteItem
}) => {


  const dispatch = useDispatch();
  const reducer = useSelector((s) => s.manageV2.deleteManage) || {};
    const { t } = useTranslation()


 useEffect(()=>{



  return ()=>{

    dispatch(resetDelete())


  }


 },[])


  useEffect(()=>{

    if (reducer.loading === "failed"){

        dispatch(showErrorToast(reducer.errorMessage || t('Failed to delete booking')));
    }
    if (reducer.loading === "succeeded"){

        dispatch(showSuccessToast(t('booking  delete successfully')));
        onClose();
      
    }


  },[reducer.loading])

  const handelDelete = ()=>{

  dispatch(deleteManageByIdAction({ mode: "booking", id: deleteItem.id}))


  }

  return (
    <Dialog open={isOpen} onClose={onClose}>
      <DialogTitle>Confirm Delete</DialogTitle>
      <DialogContent>
        <DialogContentText>

          Warning: Are you sure you want to delete all data associated with this booking? This action cannot be undone. Once deleted, the information cannot be recovered. Are you absolutely certain you wish to proceed?
        </DialogContentText>
       

      
          <Typography>

            <>
            <br/>
            Booking Number : {deleteItem.number}
            </>

          </Typography>

      </DialogContent>

      <DialogActions>
        {reducer.loading === 'pending' ? <Progress Msg='Loading ...' /> :
        <>
        <Button onClick={onClose} variant="b2">
          Cancel
        </Button>
        <Button
          variant="b1"
          onClick={()=>handelDelete()}

        >
          Delete
        </Button>
        </>
          }
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmationModal;
